<template>
	<aside class="auth-brand-panel">
		<!-- 背景装饰球 -->
		<div class="bp-orb bp-orb--1"></div>
		<div class="bp-orb bp-orb--2"></div>
		<div class="bp-orb bp-orb--3"></div>

		<!-- 内容层 -->
		<div class="bp-body">
			<div class="bp-brand">
				<img class="bp-logo" :src="brandLogo" :alt="brandName" width="44" height="44">
				<span class="bp-name">{{ brandName }}</span>
			</div>
			<!-- 文案 -->
			<div class="bp-copy">
				<h2 class="bp-title">{{ $t('register.brandHeadline') }}</h2>
				<p class="bp-desc">{{ $t('register.brandTagline') }}</p>
			</div>

			<!-- 产品 UI 模拟窗口 -->
			<div class="app-mock">
				<!-- macOS 式标题栏 -->
				<div class="am-bar">
					<span class="am-dot am-dot--r"></span>
					<span class="am-dot am-dot--y"></span>
					<span class="am-dot am-dot--g"></span>
					<span class="am-bar__title">{{ $t('register.previewGroupName') }}</span>
				</div>
				<!-- 两栏布局 -->
				<div class="am-body">
					<!-- 左侧会话列表 -->
					<nav class="am-sidebar">
						<div class="am-search">
							<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2.5" stroke-linecap="round">
								<circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
							</svg>
							<div class="am-search__bar"></div>
						</div>
						<div v-for="(item, i) in sidebarItems" :key="i"
							class="am-item" :class="{ 'am-item--active': i === 0 }">
							<div class="am-item__av" :style="{ background: item.color }"></div>
							<div class="am-item__meta">
								<div class="am-item__name"></div>
								<div class="am-item__preview"></div>
							</div>
							<div v-if="item.badge" class="am-item__badge">{{ item.badge }}</div>
						</div>
					</nav>
					<!-- 右侧聊天区 -->
					<div class="am-chat">
						<div class="am-chat__hd">
							<div class="am-chat__title"></div>
						</div>
						<div class="am-msgs">
							<div class="am-msg am-msg--in">
								<div class="am-av" style="background:#f59e0b"></div>
								<div class="am-bubble am-bubble--in" style="width:58%"></div>
							</div>
							<div class="am-msg am-msg--in am-msg--cont">
								<div class="am-bubble am-bubble--in" style="width:42%"></div>
							</div>
							<div class="am-msg am-msg--out">
								<div class="am-bubble am-bubble--out" style="width:52%"></div>
							</div>
							<div class="am-msg am-msg--in">
								<div class="am-av" style="background:#10b981"></div>
								<div class="am-bubble am-bubble--in" style="width:65%"></div>
							</div>
							<div class="am-msg am-msg--out">
								<div class="am-bubble am-bubble--out" style="width:38%"></div>
							</div>
						</div>
						<div class="am-input">
							<div class="am-input__field"></div>
							<div class="am-input__btn">
								<svg width="10" height="10" viewBox="0 0 24 24" fill="white">
									<path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
								</svg>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 底部数据统计 -->
			<div class="bp-stats">
				<div class="bp-stat">
					<span class="bp-stat__num">10K+</span>
					<span class="bp-stat__lbl">{{ $t('register.statUsers') }}</span>
				</div>
				<div class="bp-stat-sep"></div>
				<div class="bp-stat">
					<span class="bp-stat__num">99.9%</span>
					<span class="bp-stat__lbl">{{ $t('register.statUptime') }}</span>
				</div>
				<div class="bp-stat-sep"></div>
				<div class="bp-stat">
					<span class="bp-stat__num">E2E</span>
					<span class="bp-stat__lbl">{{ $t('register.statEncrypt') }}</span>
				</div>
			</div>
		</div>
	</aside>
</template>

<script>
export default {
	name: 'AuthBrandPanel',
	computed: {
		brandName() {
			return process.env.VUE_APP_NAME || '喵汪村科技';
		},
		brandLogo() {
			return process.env.BASE_URL + 'branding/mark-512.png';
		},
		sidebarItems() {
			return [
				{ color: '#4169de', badge: 3 },
				{ color: '#10b981', badge: 1 },
				{ color: '#f59e0b', badge: null },
				{ color: '#6744b8', badge: null },
				{ color: '#ef4444', badge: null },
			];
		}
	}
}
</script>

<style scoped lang="scss">
// ─── 根节点：官网蓝紫浅底 ─────────────────────────
.auth-brand-panel {
	position: relative;
	flex: 0 0 380px;
	display: flex;
	align-items: stretch;
	overflow: hidden;
	// 沿用公司官网蓝紫配色
	background: linear-gradient(145deg, #f3f7ff 0%, #f5f3fc 100%);
}

// ─── 装饰球（白色半透明圆形光晕） ────────────
.bp-orb {
	position: absolute;
	border-radius: 50%;
	pointer-events: none;

	&--1 {
		// 右上大球
		width: 300px;
		height: 300px;
		top: -120px;
		right: -100px;
		background: rgba(65, 105, 222, 0.06);
	}

	&--2 {
		// 左下中球
		width: 220px;
		height: 220px;
		bottom: -80px;
		left: -70px;
		background: rgba(103, 68, 184, 0.05);
	}

	&--3 {
		// 右侧小球
		width: 130px;
		height: 130px;
		bottom: 28%;
		right: -45px;
		background: rgba(65, 105, 222, 0.04);
	}
}

// ─── 内容容器 ─────────────────────────────────
.bp-body {
	position: relative;
	z-index: 1;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 20px;
	padding: 36px 28px;
	box-sizing: border-box;
	animation: bpIn 0.5s cubic-bezier(0.4, 0, 0.2, 1) both;
}

@keyframes bpIn {
	from {
		opacity: 0;
		transform: translateY(12px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
}

// ─── 品牌 ─────────────────────────────────────
.bp-brand {
	display: flex;
	align-items: center;
	gap: 10px;
}

.bp-logo {
	width: 44px;
	height: 44px;
	flex: 0 0 auto;
	object-fit: contain;
}

.bp-name {
	font-size: 17px;
	font-weight: 700;
	color: #152443;
}

// ─── 文案 ─────────────────────────────────────
.bp-title {
	margin: 0 0 6px;
	font-size: 21px;
	font-weight: 700;
	line-height: 1.4;
	color: #152443;
	letter-spacing: -0.2px;
}

.bp-desc {
	margin: 0;
	font-size: 12.5px;
	line-height: 1.7;
	color: #3353b8;
	max-width: 290px;
}

// ─── 产品 UI 模拟窗口 ─────────────────────────
.app-mock {
	border-radius: 10px;
	background: #fff;
	overflow: hidden;
	box-shadow:
		0 12px 32px rgba(65, 105, 222, 0.12),
		0 0 0 1px rgba(0, 0, 0, 0.06);
}

// macOS 标题栏
.am-bar {
	height: 30px;
	background: #f1f5f9;
	border-bottom: 1px solid #e2e8f0;
	display: flex;
	align-items: center;
	padding: 0 10px;
	gap: 5px;
}

.am-dot {
	display: inline-block;
	width: 8px;
	height: 8px;
	border-radius: 50%;

	&--r {
		background: #ff5f57;
	}

	&--y {
		background: #febc2e;
	}

	&--g {
		background: #28c840;
	}
}

.am-bar__title {
	flex: 1;
	text-align: center;
	font-size: 10px;
	font-weight: 500;
	color: #64748b;
}

// 两栏主体
.am-body {
	display: flex;
	height: 195px;
}

// ── 左侧会话列表 ──
.am-sidebar {
	width: 108px;
	flex-shrink: 0;
	background: #f8fafc;
	border-right: 1px solid #d9e0f0;
	padding: 7px 0;
	overflow: hidden;
}

.am-search {
	display: flex;
	align-items: center;
	gap: 4px;
	margin: 0 7px 6px;
	height: 18px;
	border-radius: 4px;
	background: #eef2f7;
	padding: 0 6px;

	.am-search__bar {
		flex: 1;
		height: 4px;
		border-radius: 2px;
		background: #dde3ed;
	}
}

.am-item {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 6px 8px;
	position: relative;
	cursor: default;

	&--active {
		background: #f5f3fc;

		&::before {
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			width: 2.5px;
			background: #4169de;
			border-radius: 0 2px 2px 0;
		}
	}

	&__av {
		width: 20px;
		height: 20px;
		border-radius: 5px;
		flex-shrink: 0;
	}

	&__meta {
		flex: 1;
		min-width: 0;
	}

	&__name {
		height: 5px;
		border-radius: 2px;
		background: #cbd5e1;
		width: 62%;
		margin-bottom: 4px;
	}

	&__preview {
		height: 4px;
		border-radius: 2px;
		background: #e2e8f0;
		width: 85%;
	}

	&__badge {
		min-width: 14px;
		height: 14px;
		border-radius: 7px;
		background: #4169de;
		color: #fff;
		font-size: 7px;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 3px;
		flex-shrink: 0;
	}
}

// ── 右侧聊天区 ──
.am-chat {
	flex: 1;
	display: flex;
	flex-direction: column;
	background: #fff;
	min-width: 0;
}

.am-chat__hd {
	height: 28px;
	border-bottom: 1px solid #f1f5f9;
	display: flex;
	align-items: center;
	padding: 0 10px;
}

.am-chat__title {
	height: 6px;
	width: 50px;
	border-radius: 3px;
	background: #cbd5e1;
}

.am-msgs {
	flex: 1;
	padding: 8px 10px 4px;
	display: flex;
	flex-direction: column;
	gap: 5px;
	justify-content: flex-end;
	overflow: hidden;
}

.am-msg {
	display: flex;
	align-items: flex-end;
	gap: 5px;

	&--out {
		justify-content: flex-end;
	}

	&--cont {
		// 连续消息，无头像，缩进对齐
		padding-left: 23px;
	}
}

.am-av {
	width: 16px;
	height: 16px;
	border-radius: 4px;
	flex-shrink: 0;
}

.am-bubble {
	height: 14px;
	border-radius: 7px;

	&--in {
		background: #f1f5f9;
		border-radius: 2px 7px 7px 7px;
	}

	&--out {
		background: linear-gradient(135deg, #6744b8, #4169de);
		border-radius: 7px 2px 7px 7px;
	}
}

// 输入框区域
.am-input {
	height: 30px;
	border-top: 1px solid #f1f5f9;
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 0 8px;

	&__field {
		flex: 1;
		height: 14px;
		border-radius: 7px;
		background: #f1f5f9;
	}

	&__btn {
		width: 20px;
		height: 20px;
		border-radius: 6px;
		background: linear-gradient(135deg, #6744b8, #4169de);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}
}

// ─── 底部统计 ─────────────────────────────────
.bp-stats {
	display: flex;
	align-items: center;
	background: rgba(255, 255, 255, 0.7);
	border: 1px solid #d9e0f0;
	border-radius: 12px;
	padding: 12px 14px;
	backdrop-filter: blur(10px);
}

.bp-stat {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 3px;
}

.bp-stat__num {
	font-size: 16px;
	font-weight: 700;
	color: #6744b8;
	line-height: 1;
}

.bp-stat__lbl {
	font-size: 10.5px;
	color: #3353b8;
}

.bp-stat-sep {
	width: 1px;
	height: 26px;
	background: #d9e0f0;
	flex-shrink: 0;
}
</style>
